import { UUID } from "crypto";

export const lotKeys = {
  all: ["lots"] as const,
  lists: () => [...lotKeys.all, "list"] as const,
  list: () => [...lotKeys.lists()] as const,
  details: () => [...lotKeys.all, "detail"] as const,
  detail: (id: UUID) => [...lotKeys.details(), id] as const,
  flows: (lotId: UUID) => [...lotKeys.all, "flows", lotId] as const,
  full: (lotId: UUID) => [...lotKeys.all, "full", lotId] as const,
};
